import { render, staticRenderFns } from "../../components/shared/contacts/ReadOnlyTemplate.html?vue&type=template&id=72d14bc0&scoped=true&"
import script from "./ReadOnlyContactModal.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyContactModal.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyContactModal.vue?vue&type=style&index=0&id=72d14bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d14bc0",
  null
  
)

component.options.__file = "ReadOnlyContactModal.vue"
export default component.exports